/* @flow */
// used by the tree-walking updates and springs. Avoids some allocations
export default function zero(): number {
  return 0;
}



/** WEBPACK FOOTER **
 ** D:/Github/react-motion/src/zero.js
 **/